import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=ae6be102"
import script from "./Tenants.vue?vue&type=script&lang=ts"
export * from "./Tenants.vue?vue&type=script&lang=ts"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=ae6be102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports